/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-11 20:01:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-27 13:17:04
 * @FilePath: /code/zeelool-nextjs/src/components/Form/Select/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import { Select as MuiSelect, SelectProps as MuiSelectProps, SxProps } from '@mui/material';
import { CollapseArrowDownOutlined } from '@zeelool/icon';
import { forwardRef, useCallback } from 'react';
import { Control, Controller, RegisterOptions, useFormContext } from 'react-hook-form';

export type SelectProps = MuiSelectProps & {
  /**
   * react-hook-form 字段名
   */
  name?: string;
  /**
   * react-hook-form 控制器
   */
  control?: Control<any>;
  /**
   * react-hook-form 验证规则
   */
  rules?: RegisterOptions;
  /**
   * 标题和输入框的布局方式，默认inline，也就是标题和输入框融为一体
   * 如果设置为vertical，那么标题和输入框会垂直排列
   */
  layout?: 'inline' | 'vertical';
  /**
   * 表单项类名
   */
  formItemClassName?: string;
  /**
   * 菜单顶部间距
   */
  menuMarginTop?: string;
  /**
   * 菜单顶部间距
   */
  menuSx?: SxProps;
  /**
   * 中心值
   */
  centerValue?: string;
  /**
   * 无边框模式，设置为true时移除边框且宽度为100%
   */
  noBorder?: boolean;
  /**
   * 默认显示值，当选择值不在列表中时显示
   */
  defaultDisplayValue?: string;
  /**
   * 占位符文本，当没有选择值时显示
   */
  placeholder?: string;
  /**
   * 是否可清空
   */
  clearable?: boolean;
  /**
   * 清空按钮点击事件
   */
  onClear?: () => void;
  /**
   * 错误提示是否使用固定定位，默认为true
   */
  errorFixed?: boolean;
};

// TODO:这里有个bug，不知道为什么Select组件一打开第一个item就是灰色的？
/**
 * Select组件，封装MUI的Select组件
 *
 * 支持以下占位符显示方式：
 * 1. placeholder: 当没有选择值时显示，优先级最高
 * 2. defaultDisplayValue: 当没有选择值且没有placeholder时显示
 * 3. label: 当layout为inline时作为输入框标签显示
 */
const Select = forwardRef<HTMLDivElement, SelectProps>((props, ref) => {
  const {
    name,
    control,
    rules,
    layout = 'inline',
    formItemClassName = 'mb-[32px]',
    menuMarginTop = '4px',
    menuSx = {},
    label,
    centerValue,
    noBorder,
    defaultDisplayValue,
    placeholder,
    clearable,
    onClear,
    errorFixed = true,
    ...otherProps
  } = props;

  // 获取表单上下文
  const formContext = useFormContext();

  // 处理失焦事件
  const handleBlur = useCallback(() => {
    // 手动触发验证
    if (formContext && name) {
      setTimeout(() => {
        formContext.trigger(name);
      }, 0);
    }
  }, [formContext, name]);

  const handleOnOpen = () => {
    const currentValue = control._formValues[name];
    if (centerValue && !control.getFieldState(name).isDirty) {
      if (currentValue && centerValue !== currentValue) {
        setTimeout(() => {
          const menuItems = document.querySelectorAll('.MuiMenuItem-root');

          menuItems.forEach((item) => {
            if (item.getAttribute('data-value') == currentValue) {
              item.scrollIntoView({ block: 'center' });
            }
          });
        }, 100);

        return;
      }

      setTimeout(() => {
        // 查找匹配centerValue的菜单项
        const menuItems = document.querySelectorAll('.MuiMenuItem-root');
        // const targetIndex = -1;

        menuItems.forEach((item) => {
          if (item.getAttribute('data-value') === centerValue) {
            item.scrollIntoView({ block: 'center' });
          }
        });
      }, 100);
    }
  };

  // 构建endAdornment
  // const getEndAdornment = (field: ControllerRenderProps<any, string>) => {
  //   // 清空按钮
  //   const clearButton =
  //     clearable && value ? (
  //       <IconButton
  //         size="small"
  //         onClick={() => {
  //           // 直接在这里处理清空逻辑
  //           // field.onChange(''); // 更新Controller值
  //           // if (name && formContext) {
  //           //   formContext.setValue(name, ''); // 更新表单值
  //           //   setTimeout(() => formContext.trigger(name), 0);
  //           // }
  //           // formContext.setValue(name, ''); // 更新表单值
  //           if (onClear) onClear();
  //         }}
  //         edge="end"
  //         aria-label="clear input"
  //       >
  //         <DeleteCircleFilled className="text-[20px] text-auxiliary-text" />
  //       </IconButton>
  //     ) : (
  //       <CollapseArrowDownOutlined />
  //     );

  //   // 否则返回常规endAdornment
  //   return clearButton;
  // };
  return (
    <Controller
      name={name || 'select'}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        return (
          <div className={`relative ${formItemClassName}`}>
            {/* 标题 - 垂直布局时显示 */}
            {layout === 'vertical' && label && (
              <label className="block text-[14px] md:text-[16px] text-primary-text font-br mb-[12px]">
                {label}
              </label>
            )}

            <MuiSelect
              ref={ref}
              // IconComponent={() => getEndAdornment(field)}
              IconComponent={CollapseArrowDownOutlined}
              onOpen={handleOnOpen}
              displayEmpty={!!defaultDisplayValue || !!placeholder}
              labelId="demo-simple-select-label"
              label={layout === 'inline' ? label : undefined}
              renderValue={(value) => {
                // 当值为空且有 placeholder 时，显示 placeholder
                if ((value === '' || value === undefined) && placeholder) {
                  return <span className="text-gray-400">{placeholder}</span>;
                }
                // 当值为空或不在列表中且有默认显示值时，显示默认值
                if ((value === '' || value === undefined) && defaultDisplayValue) {
                  return defaultDisplayValue;
                }
                // 否则使用正常的值
                return value;
              }}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                PaperProps: {
                  style: {
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    marginTop: menuMarginTop,
                    maxHeight: '316px',
                    border: '1px solid #DCDFE6',
                  },
                  sx: {
                    ...menuSx,
                  },
                },
              }}
              error={!!error}
              {...field}
              onBlur={handleBlur}
              {...otherProps}
              onChange={(event, child) => {
                field.onChange(event, child);
                if (otherProps.onChange) {
                  otherProps.onChange(event, child);
                }
                // 可以在这里添加额外的onChange逻辑
              }}
              sx={{
                // 图标字体大小设置 - 适用于所有情况
                '& .MuiSelect-iconOutlined': {
                  fontSize: {
                    xs: '18px',
                    lg: '20px',
                  },
                },
                '& .MuiSelect-iconOutlined:not(.Mui-disabled)': {
                  color: '#808080',
                },
                ...(noBorder && {
                  width: '100%',
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '& .MuiSelect-select': {
                    padding: '0',
                  },
                }),
                ...otherProps.sx,
              }}
            />

            {/* 错误信息展示 */}
            <div
              className={`
                ${errorFixed ? 'absolute left-0 top-full' : 'relative'} text-error text-[12px] pt-[4px]
                transition-all duration-200 ease-in-out
                ${error ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-1 pointer-events-none'}
              `}
            >
              {error?.message}
            </div>
          </div>
        );
      }}
    />
  );
});

Select.displayName = 'Select';

export default Select;
